import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { u as a } from "./index-6a632112.mjs";
import { c as e, s as o, r as f, k as d, e as m } from "./themes-5f0b3c3d.mjs";
import { l as $ } from "./lineHeights-72d3110c.mjs";
import { t as h } from "./textStyles-42cab346.mjs";
import { useState as v } from "react";
import { CloseButton as C } from "./closeButton.js";
import "./fontWeights-a25f8f91.mjs";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./accessibility.js";
function p(t) {
  return t === "default" ? e.brandTwilight[1e3] : t === "accent" ? e.accentBlue[1200] : t === "success" ? e.utilitySuccess[1200] : t === "caution" ? e.utilityCaution[1200] : e.utilityDanger[1200];
}
function x(t) {
  return t === "default" ? e.brandTwilight[300] : t === "accent" ? e.accentBlue[100] : t === "success" ? e.utilitySuccess[100] : t === "caution" ? e.utilityCaution[100] : e.utilityDanger[100];
}
const k = a.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: ${o["2x"]};
  padding: 0px ${o["2x"]};
  margin: 0;
  border-radius: ${f["1x"]};
  height: ${o["6x"]};
  color: ${(t) => t?.$variant && p(t.$variant)};
  background-color: ${(t) => t?.$variant && x(t.$variant)};
`, w = a.span`
  display: inline-block;
  line-height: ${$.small};
  font-family: ${d};
  font-size: ${h.body.medium.s.fontSize};
  font-weight: ${m.regular.S.fontWeight};
`, B = a(C)`
  &:hover {
    cursor: pointer;
    background-color: ${(t) => t.$variant === "default" ? t.theme.components.tag.backgroundColor.hoverDefault : t.$variant === "accent" ? t.theme.components.tag.backgroundColor.hoverAccent : t.$variant === "green" ? t.theme.components.tag.backgroundColor.hoverSuccess : t.$variant === "orange" ? t.theme.components.tag.backgroundColor.hoverCaution : t.theme.components.tag.backgroundColor.hoverDanger} !important;
  }
`, E = ({ variant: t = "default", title: i, onDelete: n }) => /* @__PURE__ */ u(k, { $variant: t, children: [
  /* @__PURE__ */ s(w, { children: i }),
  !!n && /* @__PURE__ */ s(
    B,
    {
      ariaLabel: "tag-close-btn",
      onClick: (r) => {
        r.preventDefault(), r.stopPropagation(), n && n();
      },
      size: "xxxsmall",
      $variant: ((r) => {
        switch (r) {
          case "accent":
            return "accent";
          case "caution":
            return "orange";
          case "danger":
            return "red";
          case "success":
            return "green";
          default:
            return "default";
        }
      })(t)
    }
  )
] }), S = a.div`
  display: flex;
`, z = a.div`
  display: flex;

  ${(t) => !t.overflow && `
    flex-wrap: wrap;
    row-gap: ${o["4x"]};
    column-gap: ${o["2x"]};
`}
`, T = a.button`
  line-height: ${$.small};
  font-family: ${d};
  font-size: ${h.body.medium.s.fontSize};
  font-weight: ${m.regular.S.fontWeight};
  padding: 0 ${o["2x"]};
  min-height: ${o["6x"]};
  border: none;
  border-radius: ${f["1x"]};
  background-color: transparent;
  color: ${(t) => t?.$variant && p(t.$variant)};
  background-color: ${(t) => t?.$variant && x(t.$variant)};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${e.accentBlue[1e3]};
  }
`, J = ({
  overflowVariant: t = "default",
  overflow: i = !1,
  children: n = [],
  onClick: l,
  visibleTags: c = 0
}) => {
  const [r, b] = v(!0), g = n.length, y = () => {
    b(!1), l && l();
  };
  return /* @__PURE__ */ s(S, { children: /* @__PURE__ */ u(z, { children: [
    r && i ? n.slice(0, c) : n,
    i && r && g - c > 0 && /* @__PURE__ */ u(
      T,
      {
        role: "button",
        $variant: t,
        onClick: y,
        children: [
          "+",
          g - c
        ]
      }
    )
  ] }) });
};
export {
  E as Tag,
  J as TagsGroup
};
